import axios from 'axios';
import {ENV_CONFIGS} from '../constants/envs';
import {addAuthToken} from '../utils/addAuthToken';
import lodashGet from 'lodash/get';
import {tokenExpired} from '../app/actions';

const USER_ENDPOINT = '/users';

export default class {
  constructor(dispatch, getState) {
    const defaultHeaders = {'Content-Type': 'application/json'};
    this.dispatch = dispatch;
    this.getState = getState;
    this.axiosClient = axios.create({
      headers: defaultHeaders
    });
    this.limit = 200;
  }

  setAxiosClient(apiConfig) {
    const {projectId} = apiConfig;
    const adminV2ApiUrl = `${ENV_CONFIGS.APIGEE_HOST}${ENV_CONFIGS.ADMIN_V2}`;
    this.axiosClient.defaults.baseURL = `${adminV2ApiUrl}/projects/${projectId}/`;
    this.setInceptors();
  }

  setInceptors() {
    this.axiosClient.interceptors.request.use(config => addAuthToken(this.getState, this.dispatch, config));
    this.axiosClient.interceptors.response.use(
      response => response.data,
      error => {
        if (lodashGet(error, 'response.status') === 401) {
          this.dispatch(tokenExpired());
        }
        return Promise.reject(error);
      }
    );
  }

  setConfig(apiConfig) {
    this.setAxiosClient(apiConfig);
  }

  /**
   * Retrieves information about all the users in a project.
   @param {integer} parameters.limit - The maximum number of records to return in a single request. Possible range: 1-200. Default Can be a number between 1 and 200.  Default value: 20.  If a number greater than 200 is provided 200 will be returned.
   @param {integer} parameters.offset - The number of records to skip before returning the result records.  Increase this value in subsequent requests to continue getting results when the number of records exceeds the requested limit.
   **/
  getProjectUsers({offset, limit}) {
    return this.axiosClient.get(`${USER_ENDPOINT}`, {params: {offset, limit}});
  }

  getPaginatedUsersInProject() {
    return this.getProjectUsers({offset: 0, limit: this.limit});
  }
}
